<template>
  <v-menu
    offset-y
    content-class="massive-actions-menu"
    @input="menuOpen = $event"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        v-bind="attrs"
        v-on="on"
        outlined
        color="primary"
        class="ml-2"
        style="border-radius: 24px; height: 43px; min-width: auto;"
      >
        <v-icon left :class="{ 'rotate-icon': menuOpen }">mdi-cog</v-icon>
        <span class="btn-text">{{ $t('massive.actions.title') }}</span>
        <v-icon right :class="{ 'rotate-icon': menuOpen }">mdi-chevron-down</v-icon>
      </v-btn>
    </template>

    <v-list class="massive-actions-list">
      <v-list-item @click="$emit('upload')">
        <v-list-item-icon>
          <v-icon color="primary">mdi-upload</v-icon>
        </v-list-item-icon>

        <v-list-item-title>
          {{ $t('massive.actions.upload') }}
        </v-list-item-title>
      </v-list-item>

      <v-list-item @click="$emit('delete')">
        <v-list-item-icon>
          <v-icon color="error">mdi-delete</v-icon>
        </v-list-item-icon>

        <v-list-item-title>
          {{ $t('massive.actions.delete') }}
        </v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
export default {
  name: 'MassiveActionsDropdown',
  data() {
    return {
      menuOpen: false
    };
  }
};
</script>

<style lang="css">
.massive-actions-menu {
  border-radius: 20px !important;
  overflow: hidden !important;
  max-width: 300px;
}

.massive-actions-menu .v-sheet {
  border-radius: 20px !important;
  overflow: hidden !important;
}

.massive-actions-menu .v-list {
  border-radius: 20px !important;
  padding: 8px !important;
  background: white;
}

.massive-actions-menu .v-list-item {
  border-radius: 14px !important;
  overflow: hidden;
  transition: all 0.2s ease;
}

.massive-actions-menu .v-list-item::before {
  border-radius: 14px !important;
}

.massive-actions-menu .v-list-item:hover {
  background-color: rgba(203, 200, 209, 0.08) !important;
}

.massive-actions-menu .v-list-item-title {
  word-break: break-word;
  white-space: normal;
  line-height: 1.4;
}

.btn-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 200px;
}

.rotate-icon {
  transform: rotate(180deg);
  transition: transform 0.3s ease;
}
</style>